export const MAINTENANCE_STATUS_CODE = 599
